<template>
  <v-row class="h-100 pa-3">
    <!-- left side -->
    <v-col cols="12" lg="8" md="8" class="d-flex" order-md="1" order="2">
      <v-sheet-rounded class="h-100 w-100 pa-6" elevation="2">
        <ue-title v-if="title"
          :text="title"
          padding=""
          class=""
        />
        <ue-title v-if="subtitle"
          :text="subtitle"
          padding=""
          class="pt-1"
          transform="none"
          weight="regular"
          type="caption"
        />
        <ue-form v-if="$isset(filterModel) && $isset(filterModel.packageables) && filterModel.packageables.length > 0"
          ref="mainForm"
          :schema="dynamicSchema"
          :modelValue="mainModel"
          @update:modelValue="updateModelValue($event)"

          v-model:valid="mainValid"
          @update:schema="updateSchema($event)"

          noDefaultSurface
          noDefaultFormPadding
        >

        </ue-form>
        <div v-else style="min-height: 85vh;" v-bind="emptyWrapperAttributes">
          <v-img :src="emptyImageUrl" v-bind="emptyImageAttributes" alt="Package Selector Empty" />
          <!-- <div class="text-h6 text-center">
            {{ $t('No package available') }}
          </div> -->
        </div>
      </v-sheet-rounded>

    </v-col>

    <!-- right side -->
    <v-col cols="12" lg="4" md="4" class="d-flex" order-md="2" order="1">
      <v-sheet-rounded class="bg-primary-darken-2 h-100 w-100 d-flex flex-column fill-height pa-6" elevation="2">
        <ue-title
          v-if="filterTitle"
          :text="filterTitle"
          padding=""
          class=""
        />

        <v-divider class="my-3" style="border-color: rgb(var(--v-theme-on-primary-darken-1));"></v-divider>

        <ue-form
          ref="filterForm"
          :modelValue="filterModel"
          @update:modelValue="updateModelValue($event, 'filter')"

          :schema="dynamicFilterSchema"
          @update:schema="updateSchema($event, 'filter')"

          v-model:valid="filterValid"
          noDefaultSurface
          noDefaultFormPadding
        >
        </ue-form>

        <v-spacer></v-spacer>

        <v-divider class="my-3"></v-divider>

        <!-- Total -->
        <v-table class="bg-transparent my-3">
          <tbody>
            <tr class="py-0">
              <td class="border-0 h-auto py-1 pl-0 text-h5 text-white">
                {{ $t('Total').toUpperCase() }}
              </td>
              <td class="border-0 h-auto py-1 d-flex justify-end pr-0 font-weight-bold">
                <slot name="summary.final.total">
                  <ue-print-request
                    v-if="calculatorUrl"
                    :payload="payload"
                    :endpoint='calculatorUrl'
                    :print-keys='{"text": "total", "subText": "vatText"}'
                    :loading-text='$t("Calculating...")'
                  />
                </slot>
              </td>
            </tr>
          </tbody>
        </v-table>

        <!-- Description -->
        <div class="text-caption text-grey-lighten-1 mb-6">
          <slot name="summary.final.description">
            <template v-if="summaryDescription">
              {{ summaryDescription }}
            </template>
          </slot>
        </div>

        <!-- Complete button -->
        <v-sheet class="pb-0 px-0 ue-stepper-form__preview-bottom bg-primary-darken-3">
          <v-btn-secondary
            class="v-stepper-form__nextButton"
            block
            :disabled="loading"
            :loading="loading"
            @click="sendRequest"
          >
            {{ submitButtonText }}
          </v-btn-secondary>
        </v-sheet>
      </v-sheet-rounded>
    </v-col>
  </v-row>

  <ue-modal
    ref="modal"
    v-model="modalActive"
    :width-type="'md'"
    :description="modalMessage"
    persistent
  >
    <template v-slot:body.description>
      <div class="d-flex flex-column align-center justify-center">
        <v-icon size="64" color="success" class="mb-4">mdi-check-circle-outline</v-icon>
        <h2 class="text-h4 mb-4 text-success">{{ $t('Request Complete') }}</h2>
        <p class="text-subtitle-1 grey--text">{{ $t('Congratulations! Your PR request is complete.') }}</p>
      </div>
    </template>
    <template v-slot:body.options>
      <div class="d-flex justify-center w-100">
        <v-btn variant="flat" color="success" @click="completed">
          {{ $t('Go Back') }}
        </v-btn>
      </div>
    </template>
  </ue-modal>
</template>

<script>
  import { getModel } from '@/utils/getFormData.js'
  import { cloneDeep, isEqual, each, map, orderBy, pick } from 'lodash-es'
  import api from '@/store/api/form'

  import { ALERT } from '@/store/mutations'

  export default {
    name: 'ue-custom-package-selector',
    props: {
      modelValue: {
        type: Object,
        default: () => ({})
      },
      title: {
        type: String,
        required: true
      },
      submitButtonText: {
        type: String,
        default: 'Complete'
      },
      subtitle: {
        type: String,
        required: true
      },
      summaryDescription: {
        type: String,
      },
      filterTitle: {
        type: String,
        required: true
      },
      schema: {
        type: Object,
        required: true
      },
      filterSchema: {
        type: Object,
        required: true
      },
      actionUrl: {
        type: String,
        // required: true
      },
      redirectUrl: {
        type: String,
        // required: true
      },
      calculatorUrl: {
        type: String,
        // required: true
      },
      emptyWrapperAttributes: {
        type: Object,
        default: () => ({})
        // required: true
      },
      emptyImageUrl: {
        type: String,
        // required: true
      },
      emptyImageAttributes: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        loading: false,

        modalActive: false,
        modalMessage: '',
        isCompleted: false,

        model: {
          ...getModel(this.schema, this.modelValue),
          ...getModel(this.filterSchema, this.modelValue),
          ...this.modelValue,
        },

        dynamicSchema: this.schema,
        dynamicFilterSchema: this.filterSchema,

        mainModel: getModel(this.schema, this.modelValue),
        filterModel: getModel(this.filterSchema, this.modelValue),

        mainValid: false,
        filterValid: false,
      }
    },
    methods: {
      completed(){
        this.modalActive = false
        if(this.redirectUrl){
          window.location.href = this.redirectUrl
        }
      },
      sendRequest() {

        if(!this.filterValid){
          this.$refs.filterForm.manualValidation = true
          this.$refs.filterForm.validate()
          this.$refs.filterForm.manualValidation = false

          return
        }

        if(!this.mainValid){
          this.$refs.mainForm.manualValidation = true
          this.$refs.mainForm.validate()
          this.$refs.mainForm.manualValidation = false

          return
        }

        let payload = {
          ...this.filterModel,
          ...this.mainModel,
        }

        const method = payload?.id ? 'put' :'post'

        this.loading = true
        const self = this

        api[method](this.actionUrl, payload, function (response) {

          if(response.data.variant === 'success'){
            if(response.data.cached ){
              self.$store.commit(ALERT.SET_ALERT, pick(response.data, ['variant', 'message', 'location', 'timeout']))
            }else{
              self.modalActive = true
            }
            // self.isCompleted = true
            // self.modalMessage = response.data.message
          } else {
            // self.modalMessage = response.data.message
            // self.modalActive = true
          }
          self.loading = false

          // redirector(response.data)

          // if (callback && typeof callback === 'function') callback(response.data)
        }, function (response) {
          self.loading = false
          __log(response)
          // if (errorCallback && typeof errorCallback === 'function') errorCallback(response.data)
        })
        // this.$emit('submit', payload)
      },
      async updateModelValue(newVal, type = null) {
        if (type === 'filter') {

          if(isEqual(this.filterModel, newVal)){
            return
          }

          const changes = Object.keys(newVal).reduce((acc, key) => {
            if (!isEqual(this.filterModel[key], newVal[key])) {
              acc[key] = {
                old: this.filterModel[key],
                new: newVal[key]
              }
            }
            return acc
          }, {})

          const self = this
          await each(changes, async (change, key) => {
            if(key === 'location'){
              this.dynamicSchema['pressReleasePackages'].items = []
            } else if(key === 'packageables'){

              // get the packageables
              let oldPackageables = change.old
              let newPackageables = change.new

              let addedPackageables = newPackageables.filter(x => !oldPackageables.includes(x))
              let removedPackageables = oldPackageables.filter(x => !newPackageables.includes(x))

              let addedPackageableItems = []
              let filterEndpoint = this.dynamicFilterSchema['location'].items.find(x => x.id === this.filterModel['location'])?.filterEndpoint
              let eagers = this.dynamicSchema['pressReleasePackages'].eagers ?? []
              let lazy = this.dynamicSchema['pressReleasePackages'].lazy ?? []
              self.loading = true

              addedPackageableItems = await Promise.all(map(addedPackageables, async (id) => {
                let res = await axios.get(filterEndpoint.replace(`:id`, id), {
                  params: {
                    eagers: eagers,
                    lazy: lazy,
                  }
                })
                return res.data
              }))

              // addedPackageableItems = this.dynamicFilterSchema['packageables'].items.filter(x => addedPackageables.includes(x.id))
              // let removedPackageableItems = this.dynamicFilterSchema['packageables'].items.filter(x => removedPackageables.includes(x.id))
              let removedPackageableItems = (this.dynamicSchema['pressReleasePackages']?.items ?? []).filter(x => removedPackageables.includes(x.id))

              let previousPackageItems = cloneDeep(this.dynamicSchema['pressReleasePackages'].items ?? [])

              let changed = false
              if( addedPackageableItems.length > 0 ){
                addedPackageableItems.forEach(x => {
                  if(!previousPackageItems.find(y => y.id === x.id)){
                    previousPackageItems.push(x)
                  }
                })
                changed = true
              }

              if( removedPackageableItems.length > 0 ){
                removedPackageableItems.forEach(x => {
                  if(previousPackageItems.find(y => y.id === x.id)){
                    previousPackageItems = previousPackageItems.filter(y => y.id !== x.id)
                  }
                })
                changed = true
              }

              if( changed ){
                this.dynamicSchema['pressReleasePackages'].items = orderBy(previousPackageItems, ['id'], ['asc'])
              }

              self.loading = false
            }

            this.filterModel[key] = change.new
          })

        } else {
          if(isEqual(this.mainModel, newVal)){
            return
          }

          let newLanguageIds = {}

          const changes = Object.keys(newVal).reduce((acc, key) => {
            if (!isEqual(this.mainModel[key], newVal[key])) {
              acc[key] = {
                old: this.mainModel[key],
                new: newVal[key]
              }

              if(key === 'pressReleasePackages'){
                Object.keys(newVal[key]).forEach(x => {
                  let _languages = newVal[key][x].packageLanguages

                  _languages.forEach(id => {
                    newLanguageIds[`${id}_content`] = []
                  })
                })
              }
            }
            return acc
          }, {})

          each(changes, (change, key) => {
            this.mainModel[key] = change.new
          })

          Object.keys(newLanguageIds).forEach(x => {
            if(!__isset(this.mainModel['content'][x])){
              this.mainModel['content'][x] = newLanguageIds[x]
            }
          })

          Object.keys(this.mainModel['content']).forEach(x => {
            if(x.match(/^(\d+)_content$/)){
              if(!Object.keys(newLanguageIds).includes(x)){
                delete this.mainModel['content'][x]
              }
            }
          })

        }
        // this.$emit('update:modelValue', this.model)
      },
      updateSchema(newVal, type = null) {
        __log('updateSchema')
        if(type === 'filter'){
          if(isEqual(this.dynamicFilterSchema, newVal)){
            return
          }
          // this.dynamicFilterSchema = newVal
        } else {
          if(isEqual(this.dynamicSchema, newVal)){
            return
          }
          __log('updateSchema', {
            old: this.dynamicSchema,
            new: newVal,
          })
          // this.dynamicSchema = newVal
        }
      },
      handleInput (event) {
        // const { on, key, obj, value } = event
        // if (on === 'input' && !!key) {
        //   let availableValue = get(this.models, key)
        //   if(JSON.stringify(availableValue) !== JSON.stringify(value)){
        //     this.pendingHandleFunctions.push((models, schemas, previewModel) => {
        //       handleEvent(models, schemas, obj.schema, index, previewModel)
        //     })
        //   }else{
        //     handleEvent(this.model, this.schema, obj.schema, index, this.previewModel)
        //   }

        // }
      }
    },

    computed: {
      payload(){
        return {
          ...this.filterModel,
          ...this.mainModel,
        }
      },
      isValid(){
        return this.filterValid && this.mainValid
      }
    },
    watch: {
      filterModel: {
        handler(newVal) {
          // __log('filterModel watch', newVal)
        },
        deep: true
      },
      dynamicSchema: {
        handler(newVal) {
          // __log('schema watch', newVal)
        },
        deep: true
      },
      dynamicFilterSchema: {
        handler(newVal) {
          // __log('filterSchema watch', newVal)
        },
        deep: true
      }
    },

    created() {
      // __log(this.schema)
      // __log(this.filterSchema)
    }
  }

</script>

